import { useEffect, useState } from 'react';
import { CurrencySortBy } from '../interfaces/Money';
import { getCurrenciesSorted } from '../api/api';
import { logger } from '../util/logger';
import useAccountConfig from '../hooks/useAccountConfig';
export default () => {
    const { accountConfig } = useAccountConfig();
    const [currencies, setCurrencies] = useState([]);
    const [currenciesIsLoading, setCurrenciesIsLoading] = useState(true);
    const [currenciesLoadingError, setCurrenciesLoadingError] = useState(false);
    useEffect(() => {
        if (currenciesIsLoading) {
            getCurrenciesSorted(CurrencySortBy.Name)
                .then((response) => {
                setCurrencies(response);
                setCurrenciesLoadingError(false);
            })
                .catch((error) => {
                logger.error(error);
                setCurrenciesLoadingError(true);
            })
                .finally(() => {
                setCurrenciesIsLoading(false);
            });
        }
    }, [currenciesIsLoading]);
    function getCurrencyById(id) {
        return currencies.find((currency) => currency.PK === id) || null;
    }
    function getCurrencyByCode(code) {
        return currencies.find((currency) => currency.Suffix === code) || null;
    }
    function getCurrentUserCurrencyOrDefault() {
        return accountConfig?.Emp.CurrencyType || getCurrencyByCode('USD');
    }
    return {
        currencies,
        currenciesIsLoading,
        currenciesLoadingError,
        getCurrentUserCurrencyOrDefault,
        getCurrencyById,
        getCurrencyByCode
    };
};
